module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project"
  }, [_c('xk-side-menus', {
    ref: "sideMenus"
  }), _vm._v(" "), _c('div', {
    staticClass: "topNav"
  }, [_c('span', {
    staticClass: "menuBut",
    on: {
      "click": _vm.menuFn
    }
  }, [_c('i', {
    staticClass: "iconfont icon-man"
  })]), _vm._v(" "), _c('div', {
    staticClass: "yewu"
  }, [_c('xk-tabs', {
    attrs: {
      "acNum": 0
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "projectContent"
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e219dab","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/project.vue
// module id = 512
// module chunks = 0